import { post, get } from '@/api/request'
import { PaginationResponse, PaginationParams } from '@/api/base'

// 百货店申请请求参数
export interface DepartmentStoreParams {
  storeName: string,
  contactName: string,
  contactPosition: string,
  contactPhone: string,
  contactEmail: string,
  cooperationDescription: string
  groupName?: string,
  country: string,
  city: string,
  address: string,
  storeLevel: string,
  businessArea: number,
  annualTraffic?: number,
  existingBrands?: string
}

export interface DepartmentStore extends DepartmentStoreParams {
  id: string,
  applicationStatus: number,
  createdAt: string,
  updatedAt: string
}

// 品牌合作加盟申请请求参数
export interface BrandApplyParams {
  brandNameCn: string,
  brandNameEn: string,
  brandCountry: string,
  establishedYear: number,
  brandPositioning: string,
  mainCategories: string,
  existingChannels: string,
  annualRevenue: number,
  companyName: string,
  contactName: string,
  contactPhone: string,
  contactEmail: string,
  cooperationDescription: string
}
export interface BrandApplyHistory extends BrandApplyParams {
  id: string,
  applicationStatus: number,
  createdAt: string,
  updatedAt: string
}

export interface DesignerApplyParams {
  designerName: string,
  brandName: string,
  designField: string,
  experienceYears: number,
  educationBackground: string,
  workExperience: string,
  representativeWorks: string,
  awards: string,
  contactPhone: string,
  contactEmail: string,
  personalIntroduction: string
}
export interface DesignerApplyHistory extends DesignerApplyParams {
  id: string,
  applicationStatus: number,
  createdAt: string,
  updatedAt: string
}

export interface OfficerApplyParams {
  applicantName: string,
  appliedPosition: string,
  experienceYears: number,
  educationBackground: string,
  workExperience: string,
  professionalSkills: string,
  projectExperience: string,
  contactPhone: string,
  contactEmail: string,
  selfIntroduction: string
}
export interface OfficerApplyHistory extends OfficerApplyParams {
  id: string,
  applicationStatus: number,
  createdAt: string,
  updatedAt: string
}

/**
 * 百货店申请
 */
export const departmentStoreApply = (params: DepartmentStoreParams) => {
  return post<DepartmentStore>('/authenti-guard/v1/api/department-store-application', params)
}

/**
 * 品牌合作申请
 */
export const brandCooperationApply = (params: BrandApplyParams) => {
  return post<BrandApplyHistory>('/authenti-guard/v1/api/brand-cooperation-application', params)
}

/**
 * 设计师入驻申请
 */
// export const getProductDetail = (productId: string) => {
//   return get<ProductInfo>(`/verification/products/${productId}`)
// }
export const designerCooperationApply = (params: DesignerApplyParams) => {
  return post<DesignerApplyHistory>('/authenti-guard/v1/api/designer-application', params)
}
/**
 * 行政官申请
 */
export const officerCooperationApply = (params: OfficerApplyParams) => {
  return post<OfficerApplyHistory>('/authenti-guard/v1/api/admin-recruitment-application', params)
}

export const queryDepartmentStoreList = (params: PaginationParams) => {
  return get<PaginationResponse<DepartmentStore>>('/authenti-guard/v1/api/department-store/list', params)
}
